// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"2665251a","502":"c3a71a48","1609":"2665251a","1803":"2665251a","3145":"2665251a","3212":"2665251a","3322":"2665251a","3365":"2665251a","9789":"2665251a","9851":"2665251a"}[chunkId] + ".chunk.css";
};